import type { QueryHookResult } from '@change-corgi/core-react/async';

type Result = { readonly data: readonly string[] };

// HOTFIX (2026-05-15): replaced the live Typesense-backed implementation that
// re-exported from the search page. The petition page consumes this only as a
// cosmetic allowlist for the momentum bar spotlight fallback category; with
// an empty allowlist the matcher returns null and the consumer falls back to
// the generic translated category. See
// https://change.slack.com/archives/C038YNYQPUZ/p1778881551894859
// Long-term: replace with a cached middle-end GraphQL field on Petition.
const EMPTY_RESULT: QueryHookResult<Result> = { status: 'loaded', data: [] };

export function useSearchTopicFacetValues(): QueryHookResult<Result> {
	return EMPTY_RESULT;
}
